import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as TooltipAD } from 'antd';
import './Tooltip.css';

function Tooltip(props) {
  // eslint-disable-next-line react/prop-types
  const { title, ...restProps } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <TooltipAD arrow={{ pointAtCenter: true }} title={title} {...restProps} />
  );
}

Tooltip.propTypes = {
  title: PropTypes.string
};

Tooltip.defaultProps = {
  title: 'primary'
};

export default Tooltip;
